import { useMemo } from 'react';

import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { useRewardTiers } from '../queries/loyalty.queries';

export const useRewardTierApplied = () => {
  const isRewardsTiersEnabled = useFlag('enable-rewards-tiers');

  const { data: rewardTiers, isFetched } = useRewardTiers();
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const incentiveSelections = useAppSelector(selectors.loyalty.selectSelectedOfferSelections);

  const rewardTierApplied = useMemo(() => {
    const fromAppliedOffers = rewardTiers?.find(tier =>
      appliedOffers.some(offer => offer.id === tier.id)
    );
    if (fromAppliedOffers) return fromAppliedOffers;
    // Get from incentiveSelections so we don't flicker when user just added reward
    return (
      rewardTiers?.find(tier => incentiveSelections?.some(s => s.incentiveId === tier.id)) ?? null
    );
  }, [rewardTiers, appliedOffers, incentiveSelections]);

  return {
    rewardTierApplied,
    isRewardTierApplied: !!rewardTierApplied,
    isFetched,
    isRewardsTiersEnabled,
  };
};
